module.exports = __webpack_public_path__ + "static/media/zola-logomark-marine.bcf3dde6.svg";